'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _leads = require('../../redux/modules/leads');






var _propertyDetails = require('../../redux/modules/propertyDetails');
var _messageModal = require('../../redux/modules/messageModal');

var _constants = require('../../constants');







var _components = require('../../components');

var _LeadsContainer = require('./LeadsContainer.scss');var styles = _interopRequireWildcard(_LeadsContainer);
var _propertySearch = require('../../redux/modules/propertySearch');
var _buyMoreQuestions = require('../../redux/modules/buyMoreQuestions');




var _index = require('../index');
var _PaymentContainer = require('../PaymentContainer/PaymentContainer');var _PaymentContainer2 = _interopRequireDefault(_PaymentContainer);
var _payments = require('../../redux/modules/payments');
var _packagesData = require('../../packagesData');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Redux
// Constants
// Components
// Styles
var LeadsContainer = function (_Component) {_inherits(LeadsContainer, _Component);function LeadsContainer(props) {_classCallCheck(this, LeadsContainer);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.
























































    getPagination = function (name) {
      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          if (selectedPages) {
            _this.setState({ rowsOnPage: selectedPages });
          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
        }
      }
    };_this.

    changePagination = function (value) {
      _this.setState({ rowsOnPage: value });
      var serializedVal = JSON.stringify(value);
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('rows-on-leads-page', serializedVal);
      }
    };_this.

    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anchor-top';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: -55 },
      options));

    };_this.

    scrollToTop = function () {
      if (_this.props.isMobile) {
        setTimeout(function () {return _this.scrollTo();}, 501);
      } else {
        _this.scrollTo();
      }
    };_this.

    handleChangeSorting = function (_ref) {var value = _ref.value;
      if (value !== _this.state.sortBy) {var _this$state =
        _this.state,search_option = _this$state.search_option,search_location = _this$state.search_location;
        _this.setState({ sortBy: value });
        var $sort = value;
        var project_id = (0, _get2.default)(_this.props, 'location.query.project_id');

        var data = {
          search_option: search_option === 'all' ? undefined : search_option,
          property_origin: search_location === 'all' ? undefined : search_location,
          project_id: project_id };



        _this.props.loadUserLeads({ token: _this.props.userToken, data: data, $sort: $sort });
      }
    };_this.

    handleChangeSortingLocation = function (_ref2) {var value = _ref2.value;
      if (value !== _this.state.search_location) {var
        search_option = _this.state.search_option;
        _this.setState({ search_location: value });
        var $sort = _this.state.sortBy;
        var project_id = (0, _get2.default)(_this.props, 'location.query.project_id');

        var data = {
          search_option: search_option === 'all' ? undefined : search_option,
          property_origin: value === 'all' ? undefined : value,
          project_id: project_id };



        _this.props.loadUserLeads({ token: _this.props.userToken, data: data, $sort: $sort });
      }
    };_this.

    handleChangeDealType = function (_ref3) {var value = _ref3.value;
      if (value !== _this.state.search_option) {var
        search_location = _this.state.search_location;
        _this.setState({ search_option: value });
        var $sort = _this.state.sortBy;
        var project_id = (0, _get2.default)(_this.props, 'location.query.project_id');

        var data = {
          search_option: value === 'all' ? undefined : value,
          property_origin: search_location === 'all' ? undefined : search_location,
          project_id: project_id };


        _this.props.loadUserLeads({ token: _this.props.userToken, data: data, $sort: $sort });
      }
    };_this.

    openDetailsPopup = function (propertyData) {
      if (_this.props.isMobile) {
        var baseRoute = propertyData.entityType === _constants.ENTITY_TYPES.PROJECT ? 'project_details' : 'home_details';
        var route = (0, _appendLocale2.default)(_this.props.locale, '/' + baseRoute + '/' + propertyData.propertyId);
        _reactRouter.browserHistory.push(route);
      } else {
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, '/profile/leads'),
          query: { id: (propertyData.entityType === _constants.ENTITY_TYPES.PROJECT ? 'project' : 'property') + '_' + propertyData.propertyId } });

        _this.props.openDetailsPopup(propertyData);
      }
    };_this.

    handleOpenBuyMoreQuestionsModal = function () {
      _this.props.openBuyMoreQuestionsModal();
    };_this.

    toggleFilters = function () {return _this.setState(function (state) {return Object.assign({},
        state, {
          mobileFiltersIsOpen: !state.mobileFiltersIsOpen });});};_this.


    handleChoosePackage = function (packageInstance) {
      _this.props.hideBuyMoreQuestionsModal();
      _this.props.changeSelectedPayment({
        type: packageInstance.type,
        checked: packageInstance.id,
        period: _packagesData.periods.FOREVER }).

      then(function () {return _this.props.openDetailsToInvoiceForm(Object.assign({},
        packageInstance, {
          checked: packageInstance.id,
          period: _packagesData.periods.FOREVER }));});

    };_this.

    handleForward = function () {
      var step = _this.props.currentPaginationStep + _this.state.rowsOnPage.value;
      if (step <= _this.props.leads.data.length) {
        _this.props.setCurrentPaginationStep(step);

        if (document) {
          _this.scrollToTop();
        }
      }
    };_this.

    handleBack = function () {
      var step = _this.props.currentPaginationStep - _this.state.rowsOnPage.value;
      _this.props.setCurrentPaginationStep(step > 1 ? step : 1);
      if (document && step >= 1) {
        _this.scrollToTop();
      }
    };_this.

    showAllLeads = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/profile/leads'));};_this.

    handleGoTo = function (val) {
      if (!Number.isNaN(val) && val >= 0) {
        _this.props.setCurrentPaginationStep(val);
        _this.setState({ selected: val });
      }
    };_this.

    reductionPurchasedLeads = function () {
      _this.props.revengeStatePayment();
      _this.props.setUserLeadsAllowed(_this.props.leadsAllowed - 1);
    };_this.

    renderSelectSorting = function () {
      var opTypesValues = Object.entries(_constants.leadsSortingConfig).map(function (_ref4) {var title = _ref4[0],value = _ref4[1];return {
          label: _this.props.translate('sortingParams', title).toString(),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_components.OMGenericSelect, {
          options: opTypesValues,
          value: _this.state.sortBy,
          onChange: _this.handleChangeSorting,
          className: styles.sortDropdown }));


    };_this.

    renderFilters = function (className) {var
      isMobile = _this.props.isMobile;
      return (
        _react2.default.createElement('div', { className: className },
          _react2.default.createElement('div', { className: styles.select },
            isMobile &&
            _react2.default.createElement('span', { className: styles.subtitle }, _this.props.translate('managePage', 'sortingType')),

            _this.renderSelectSorting()),

          _react2.default.createElement('div', { className: styles.select },
            isMobile && _react2.default.createElement('span', { className: styles.subtitle }, _this.props.translate('managePage', 'dealType')),
            _this.renderSelectDealType()),

          _react2.default.createElement('div', { className: styles.select },
            isMobile && _react2.default.createElement('span', { className: styles.subtitle }, _this.props.translate('managePage', 'locationType')),
            _this.renderSelectLocation())));



    };_this.

    renderSelectLocation = function () {
      var opTypesValues = _constants.optionTypesPropertyLocation.map(function (_ref5) {var title = _ref5.title,value = _ref5.value;return {
          label: _this.props.translate('search_box', 'searchContainer', title).toString(),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_components.OMGenericSelect, {
          options: opTypesValues,
          value: _this.state.search_location,
          onChange: _this.handleChangeSortingLocation,
          className: styles.sortDropdown }));


    };_this.

    renderSelectDealType = function () {
      var translate = _this.props.translate('search_box');
      var opTypesValues = _constants.optionTypesValuesWithAll.map(function (_ref6) {var title = _ref6.title,value = _ref6.value;return {
          label: translate('searchContainer', title).toString(),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_components.OMGenericSelect, {
          options: [].concat(opTypesValues, [{ label: translate('projects'), value: _constants.ENTITY_TYPES.PROJECT }]),
          value: _this.state.search_option,
          onChange: _this.handleChangeDealType,
          className: styles.sortDropdown }));


    };_this.

    renderLeadsList = function () {var
      rowsOnPage = _this.state.rowsOnPage;
      var firstIndex = _this.props.currentPaginationStep - 1;
      return (
        _react2.default.createElement(_components.LeadsList, {
          setDensityUnreadLeads: _this.props.setDensityUnreadLeads,
          numberUnreadLeads: _this.props.numberUnreadLeads,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          translate: _this.props.translate,
          data: _this.props.leads.data,
          openDetailsPopup: _this.openDetailsPopup,
          sendViewLeadPhone: _this.props.sendViewLeadPhone,
          userToken: _this.props.userToken,
          firstIndex: firstIndex,
          rowsOnPage: rowsOnPage,
          openMessageModal: _this.props.openMessageModal,
          hideMessageModal: _this.props.hideMessageModal,
          userLeads: _this.props.userLeads,
          handleOpenBuyModal: _this.handleOpenBuyMoreQuestionsModal,
          canOpenLead: !!(_this.props.userLeads && _this.props.userLeads.allowed),
          changeNumberLeads: _this.reductionPurchasedLeads }));


    };_this.state = { sortBy: _constants.leadsSortingConfig[_constants.SORTING_NEWEST_FIRST], search_option: 'all', search_location: 'all', step: 5, rowsOnPage: { value: 10, label: 10 }, selected: 1, mobileFiltersIsOpen: false };return _this;}LeadsContainer.prototype.componentWillMount = function componentWillMount() {var project_id = (0, _get2.default)(this.props, 'location.query.project_id');this.props.loadUserLeads({ token: this.props.userToken, data: { project_id: project_id } });if (!this.props.leadsAllowed || this.props.leadsAllowed !== this.props.userLeads.allowed) {this.props.setUserLeadsAllowed(this.props.userLeads ? this.props.userLeads.allowed : 0);}};LeadsContainer.prototype.componentDidMount = function componentDidMount() {this.getPagination('rows-on-leads-page');if (this.props.isMobile) {this.props.suppressLoading(false);} else {var id = (0, _get2.default)(this.props, 'location.query.id');if (id) {var separatorIdx = id.indexOf('_');var entityType = id.slice(0, separatorIdx);var propertyId = id.slice(separatorIdx + 1);this.props.openDetailsPopup({ entityType: entityType, propertyId: propertyId });}}};LeadsContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.location !== this.props.location) {var project_id = (0, _get2.default)(nextProps, 'location.query.project_id');this.props.loadUserLeads({ token: this.props.userToken, data: { project_id: project_id } });}if (!nextProps.isDetailsModalOpen && this.props.isDetailsModalOpen) {var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),_browserHistory$getCu2 = _browserHistory$getCu.pathname,pathname = _browserHistory$getCu2 === undefined ? '/' : _browserHistory$getCu2;_reactRouter.browserHistory.push({ pathname: pathname, query: {} });}};LeadsContainer.prototype.

  renderPagination = function renderPagination() {var _this2 = this;var _props =
    this.props,translate = _props.translate,currentPaginationStep = _props.currentPaginationStep,total = _props.leads.meta.total;var
    rowsOnPage = this.state.rowsOnPage;
    var nextStart = currentPaginationStep + rowsOnPage.value - 1;
    var lastProperty = nextStart < total ? nextStart : total;
    var options = [
    { value: 10, label: 10 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 500, label: 500 }];

    var desktopPagination =
    _react2.default.createElement('div', { className: styles.paginationBlock },
      _react2.default.createElement('div', { className: styles.navigateBtn },
        _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })),
        _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' }))),

      _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + total),
      _react2.default.createElement('div', { className: styles.inputSection },
        _react2.default.createElement('span', null, translate('managePage', 'goTo')),
        _react2.default.createElement('div', { className: styles.inputWrapper },
          _react2.default.createElement('input', {
            type: 'number',
            value: this.state.selected,
            onChange: function onChange(val) {return _this2.handleGoTo(+val.target.value);} }))),



      _react2.default.createElement('div', { className: styles.inputSection },
        _react2.default.createElement('span', { className: styles.showRows }, translate('managePage', 'showRows')),
        _react2.default.createElement(_reactSelect2.default, {
          name: 'rows-on-leads-page',
          value: this.state.rowsOnPage,
          options: options,
          onChange: this.changePagination,
          clearable: false,
          searchable: false })));





    var mobilePagination =
    _react2.default.createElement('div', { className: styles.paginationBlock },
      _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })),
      _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + total),
      _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' })));



    return this.props.isMobile ? mobilePagination : desktopPagination;
  };LeadsContainer.prototype.

  render = function render() {var _props2 =
    this.props,_props2$leads = _props2.leads,data = _props2$leads.data,meta = _props2$leads.meta,loading = _props2.loading,_props2$userLeads = _props2.userLeads,unlimited = _props2$userLeads.unlimited,until = _props2$userLeads.until;
    var allowedLeadsCount = this.props.leadsAllowed || 0;
    var project_id = (0, _get2.default)(this.props, 'location.query.project_id');

    var promotionUntilDate = until && (0, _moment2.default)(until);
    var promotionUntilDateFormatted = promotionUntilDate && promotionUntilDate.utc().format('DD/MM/YYYY');

    if (this.props.paymentSuccess && this.props.userLeads.allowed > allowedLeadsCount) {
      this.props.setUserLeadsAllowed(this.props.userLeads.allowed);
    }

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
        !this.props.withoutTitle &&
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement(_components.OMTitle, {
            title: this.props.translate('editProfile', 'leads'),
            className: 'pageTitle' }),

          _react2.default.createElement('div', { className: styles.betaVersion },
            this.props.translate('buyMoreQuestions', 'betaVersion'))),



        _react2.default.createElement('div', { className: styles.filtersBlock },
          _react2.default.createElement('div', { className: styles.container },
            this.props.isMobile ?
            _react2.default.createElement('div', { className: styles.filtersList },
              _react2.default.createElement(_components.OMAccordion, {
                  accordionOpen: this.state.mobileFiltersIsOpen,
                  onOpen: this.toggleFilters,
                  onClose: this.toggleFilters,
                  titleValue:
                  _react2.default.createElement('div', { className: styles.filtersTitle },
                    _react2.default.createElement('span', { className: styles.title }, this.props.translate('managePage', 'filters')),
                    _react2.default.createElement('span', { className: 'icon icon-bar' })),


                  className: styles.filtersAccordion },

                this.renderFilters(styles.filtersWrapper))) :


            this.renderFilters(styles.filtersList),
            _react2.default.createElement('div', { className: styles.questionsInfoContainer },
              !unlimited &&
              _react2.default.createElement('div', { className: styles.betaVersion },
                this.props.translate('buyMoreQuestions', 'betaVersion')),


              !unlimited &&
              _react2.default.createElement('span', { className: styles.questionsCount },
                _react2.default.createElement('b', { className: styles.boldText }, allowedLeadsCount), '\xA0',
                this.props.translate('buyMoreQuestions', 'leadsCanOpen')),


              unlimited ?

              _react2.default.createElement(_components.BottomTooltip, {
                closeOnClickOutside: true,
                className: 'leadsContainer',
                icon:
                _react2.default.createElement('button', {
                    className: styles.buyMoreButton,
                    disabled: true },

                  this.props.translate('buyMoreQuestions', 'buyMore')),


                msg: _react2.default.createElement('span', null, this.props.translate('buyMoreQuestions', 'tooltip'), ' - ', promotionUntilDateFormatted),
                showOnHover: true }) :

              _react2.default.createElement('button', {
                  onClick: this.handleOpenBuyMoreQuestionsModal,
                  className: styles.buyMoreButton },

                this.props.translate('buyMoreQuestions', 'buyMore'))))),





        project_id &&
        _react2.default.createElement('div', { className: styles.filtersBlock },
          _react2.default.createElement('div', { className: styles.container },
            _react2.default.createElement('div', { className: styles.showAllLeads },
              _react2.default.createElement('p', null, this.props.translate('buyMoreQuestions', 'showAllLeads')),
              _react2.default.createElement('span', { onClick: this.showAllLeads, className: 'icon icon-close' })))),




        loading ?

        _react2.default.createElement('div', { className: styles.spinnerPosition },
          _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) })) :


        _react2.default.createElement('div', { className: styles.leadsContainer },
          data && this.renderLeadsList(),
          meta && this.renderPagination()),




        this.props.isBuyMoreQuestionsModalOpen &&
        _react2.default.createElement(_index.BuyMoreQuestions, {
          translate: this.props.translate,
          buyMoreQuestions: this.props.buyMoreQuestions,
          isOpen: true,
          onRequestClose: this.props.hideBuyMoreQuestionsModal,
          openBuyMoreQuestionsModal: this.props.openBuyMoreQuestionsModal,
          changeBuyMoreQuestionsModalType: this.props.changeBuyMoreQuestionsModalType,
          isMobile: this.props.isMobile,
          locale: this.props.locale,
          handleChoosePackage: this.handleChoosePackage })));




  };return LeadsContainer;}(_react.Component);


LeadsContainer.propTypes = {
  authUserByToken: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  withoutTitle: _propTypes2.default.bool,
  userEmail: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  leads: _propTypes2.default.object,
  userLeads: _propTypes2.default.object,
  setCurrentPaginationStep: _propTypes2.default.func,
  currentPaginationStep: _propTypes2.default.number,
  openDetailsPopup: _propTypes2.default.func,
  openBuyMoreQuestionsModal: _propTypes2.default.func,
  hideBuyMoreQuestionsModal: _propTypes2.default.func,
  changeBuyMoreQuestionsModalType: _propTypes2.default.func,
  suppressLoading: _propTypes2.default.func,
  location: _propTypes2.default.object,
  isDetailsModalOpen: _propTypes2.default.bool,
  loadUserLeads: _propTypes2.default.func,
  buyMoreQuestions: _propTypes2.default.object,
  isBuyMoreQuestionsModalOpen: _propTypes2.default.bool,
  sendViewLeadPhone: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  openDetailsToInvoiceForm: _propTypes2.default.func,
  changeSelectedPayment: _propTypes2.default.func,
  revengeStatePayment: _propTypes2.default.func,
  setDensityUnreadLeads: _propTypes2.default.func,
  setUserLeadsAllowed: _propTypes2.default.func,
  numberUnreadLeads: _propTypes2.default.number,
  leadsAllowed: _propTypes2.default.number,
  paymentSuccess: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    userEmail: (0, _get2.default)(state, 'userAuthentication.data.email'),
    userLeads: (0, _get2.default)(state, 'userAuthentication.data.leads'),
    loading: state.leads.loading,
    currentPaginationStep: state.leads.currentPaginationStep,
    isDetailsModalOpen: state.propertyDetails.isDetailsModalOpen,
    leads: state.leads.data,
    leadsAllowed: state.leads.userLeadsAllowed,
    numberUnreadLeads: state.leads.numberUnreadLeads,
    buyMoreQuestions: state.buyMoreQuestions,
    isBuyMoreQuestionsModalOpen: state.buyMoreQuestions.isBuyMoreQuestionsModalOpen };};


var mapDispatchToProps = {
  loadUserLeads: _leads.loadUserLeads,
  setCurrentPaginationStep: _leads.setCurrentPaginationStep,
  suppressLoading: _propertySearch.suppressLoading,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  sendViewLeadPhone: _leads.sendViewLeadPhone,
  openBuyMoreQuestionsModal: _buyMoreQuestions.openBuyMoreQuestionsModal,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  hideBuyMoreQuestionsModal: _buyMoreQuestions.hideBuyMoreQuestionsModal,
  changeBuyMoreQuestionsModalType: _buyMoreQuestions.changeBuyMoreQuestionsModalType,
  changeSelectedPayment: _payments.changeSelectedPayment,
  setDensityUnreadLeads: _leads.setDensityUnreadLeads,
  setUserLeadsAllowed: _leads.setUserLeadsAllowed };exports.default =


(0, _PaymentContainer2.default)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
LeadsContainer));module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LeadsContainer/LeadsContainer.js
// module id = 2982
// module chunks = 0